var map = {
	"./basme/3.jpg": "d849",
	"./cacealma/3.jpg": "cacf",
	"./gewalt/3.jpg": "853d",
	"./jurnal-tetelu/3.jpg": "fe8a",
	"./la-inceput/3.jpg": "76a4",
	"./nichita/3.jpg": "ee7f",
	"./oaianeagra/3.jpg": "62ed",
	"./peei/3.jpg": "0c50",
	"./scrisoare-tata/3.jpg": "6517",
	"./scrisori-front/3.jpg": "3c71",
	"./urletul/3.jpg": "359f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4ba4";